module.exports = __webpack_public_path__ + "static/media/onboard1.17f0ef3b.png";